(() => {
  const script = document.querySelector('script[data-rdtn-shipping-merch]');
  if (!script) return;

  const country = (script.dataset.country || '').toUpperCase();
  const mix3Url = script.dataset.mix3Url || '/collections/mix-3-ship-free';
  const shippingUrl = script.dataset.shippingUrl || '/policies/shipping-policy';
  const europe79 = new Set(['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB']);
  const freeNoMinimum = new Set(['TW','HK','MO']);
  const threshold159 = new Set(['US','CA','AU','NZ']);
  let syncTimer;
  let syncInFlight = false;

  function shippingRule() {
    if (freeNoMinimum.has(country)) return { threshold: 0, label: 'Free standard shipping.' };
    if (threshold159.has(country)) return { threshold: 15900, label: 'Free standard shipping on $159+ orders.' };
    if (europe79.has(country)) return { threshold: 7900, label: 'Free standard shipping on $79+ orders.' };
    return { threshold: null, label: 'Regional free-shipping offers are available.' };
  }

  const formatUsd = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);

  function repairLegacyShippingCopy() {
    document.querySelectorAll('p').forEach((paragraph) => {
      if (!paragraph.textContent.includes('Free worldwide shipping on all orders.')) return;
      paragraph.innerHTML = paragraph.innerHTML.replace(
        /Free worldwide shipping on all orders\.\s*(?:<br\s*\/?>(?:\s|&nbsp;)*)?FedEx Express available for \$19 USD\.\s*(?:<br\s*\/?>(?:\s|&nbsp;)*)?Free FedEx on orders over \$159 USD\./i,
        'Shipping rates and free-shipping thresholds vary by destination. Final options are shown at checkout.'
      );
    });
  }

  function renderProductMessage() {
    const isProductPage = document.querySelector('product-information, .product-information, [data-product-id]');
    if (!isProductPage) return;

    const existingNote = document.querySelector('.rdtn-pdp-shipping-note');
    if (existingNote) return;

    const taxParagraph = Array.from(document.querySelectorAll('main p')).find((node) =>
      node.textContent.trim().startsWith('U.S. customers now enjoy 0 import tax')
    );

    const rule = shippingRule();
    const note = document.createElement('div');
    note.className = 'rdtn-pdp-shipping-note';
    note.setAttribute('role', 'note');

    let html = `<strong>${rule.label}</strong>`;
    if (country === 'US') {
      html += '<br>U.S. orders: import duties covered and no sales tax. ' +
        `<a href="${mix3Url}">Mix any 3 eligible items</a> for another free-shipping option.`;
    } else {
      html += `<br><a href="${shippingUrl}">See shipping details</a> for your destination.`;
    }
    note.innerHTML = html;

    if (taxParagraph) {
      const wrapper = taxParagraph.closest('.text, .rte, [class*="text-"]') || taxParagraph;
      wrapper.replaceWith(note);
      return;
    }

    const addButton = document.querySelector('main button[name="add"], main [name="add"]');
    const buyArea = addButton?.closest('buy-buttons, product-form, .buy-buttons, form');
    if (buyArea) buyArea.insertAdjacentElement('afterend', note);
  }

  function renderCartMessage(cart) {
    const containers = document.querySelectorAll('#cart-drawer .cart-totals, main .cart-totals');
    if (!containers.length) return;

    const rule = shippingRule();
    containers.forEach((container) => {
      let box = container.querySelector('.rdtn-shipping-cart-promo');
      if (!box) {
        box = document.createElement('div');
        box.className = 'rdtn-shipping-cart-promo';
        const totalContainer = container.querySelector('.cart-totals__container');
        if (totalContainer) container.insertBefore(box, totalContainer);
        else container.prepend(box);
      }

      const currency = (cart.currency || '').toUpperCase();
      let headline = rule.label;
      let progress = null;

      if (currency === 'USD' && rule.threshold !== null) {
        if (rule.threshold === 0) {
          headline = 'Free standard shipping available.';
          progress = 100;
        } else if (cart.total_price >= rule.threshold) {
          headline = `Free standard shipping unlocked at ${formatUsd(rule.threshold)}.`;
          progress = 100;
        } else {
          const remaining = Math.max(0, rule.threshold - cart.total_price);
          headline = `${formatUsd(remaining)} away from free standard shipping.`;
          progress = Math.max(0, Math.min(100, (cart.total_price / rule.threshold) * 100));
        }
      }

      let sub = `<a href="${shippingUrl}">Shipping details</a>`;
      if (country === 'US') {
        sub = `Another option: <a href="${mix3Url}">Mix any 3 eligible items</a>. Final eligibility is confirmed at checkout.`;
      }

      const track = progress === null ? '' : `
        <div class="rdtn-shipping-cart-promo__track" aria-hidden="true">
          <span class="rdtn-shipping-cart-promo__fill" style="width:${progress}%"></span>
        </div>`;

      box.innerHTML = `
        <p class="rdtn-shipping-cart-promo__headline">${headline}</p>
        ${track}
        <p class="rdtn-shipping-cart-promo__sub">${sub}</p>
      `;
    });
  }

  async function syncCart() {
    if (syncInFlight) return;
    syncInFlight = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      renderCartMessage(cart);
    } catch (_) {
      // Leave checkout untouched if cart state cannot be read.
    } finally {
      syncInFlight = false;
    }
  }

  function scheduleSync(delay = 120) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      repairLegacyShippingCopy();
      renderProductMessage();
      syncCart();
    }, delay);
  }

  function init() {
    repairLegacyShippingCopy();
    renderProductMessage();
    syncCart();

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        if (!target) return false;
        if (target.closest('.rdtn-shipping-cart-promo, .rdtn-pdp-shipping-note')) return false;
        return target.closest('#cart-drawer, main') !== null;
      });
      if (relevant) scheduleSync();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', (event) => {
      if (event.target.closest?.('#cart-drawer, form[action*="/cart"]')) scheduleSync(250);
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('#cart-drawer, button[name="add"], [name="add"]')) scheduleSync(350);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
